module.exports = __webpack_public_path__ + "static/media/banner.0cff48d6.mp4";